import { useEffect } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';
import { EditContactRequest } from 'vopay';
import useDataFetchIndicator from '@/hooks/useDataFetchIndicator';

const hook = vopayApi.withApiHook(({ api }) => {
  return function usePostEditContact() {
    const source = axios.CancelToken.source();
    const [, setDataFetchingInfo] = useDataFetchIndicator();

    const editContact = async (params: EditContactRequest) => {
      try {
        setDataFetchingInfo(true, '', 'fullScreen', false);
        const response = await api.editContact(params, source);
        return response;
      } catch (err) {
        console.error(err);
        throw err;
      } finally {
        setDataFetchingInfo(false, '', 'fullScreen', false);
      }
    };

    useEffect(() => {
      return () => {
        source.cancel();
      };
    }, []);

    return {
      editContact,
    };
  };
});

export default hook({});
